import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { addLocale, replace } from '../misc';
import RichText from '../richText';
import { Image } from '../design/elements';
import request, { sof2ApiHost } from '../utils/request';
import { sof2HomeUrl } from '../utils/constant';

const FormCategory = ({ category, row, locale, history }) => {
  const {
    name,
    title,
    image,
    description,
    info,
    importantInfo,
    forms,
    platform
  } = category;
  const style = {
    padding: '20px',
    marginTop: row ? '20px' : '',
    backgroundColor: row % 2 ? '#F5F6F7' : 'white',
    display: 'flex'
  };
  const addLocaleToUrl = addLocale(locale);

  return (
    <div style={style}>
      <div
        className="hidden-xs hidden-sm"
        style={{
          display: 'inline-block',
          marginRight: '20px',
          verticalAlign: 'top',
          minWidth: '180px'
        }}
      >
        <Image image={image} />
      </div>
      <div style={{ display: 'inline-block', verticalAlign: 'top' }}>
        <div style={{ fontWeight: 'bold' }}>
          <h2>{title}</h2>
        </div>
        <div style={{ color: '#999999' }}>
          <span className="frg-body-font-14px">
            {description && (
              <b>
                <span style={{ color: '#49166d' }}>
                  <RichText data={description} />
                </span>
              </b>
            )}
            {info && (
              <>
                <br />
                {info}
              </>
            )}
            {importantInfo && (
              <>
                <br />
                <b>
                  <span style={{ color: '#C12335' }}>{importantInfo}</span>
                </b>
              </>
            )}
          </span>
        </div>

        {forms && (
          <div style={{ paddingTop: '20px' }}>
            {forms.map((form, index) => {
              const key = `form${index}`;
              const url = addLocaleToUrl(
                `/${replace(name)}/${replace(form.fields.name)}/`
              );
              return (
                <>
                  {!form.fields.hideOnDashboard && (
                    <Fragment key={key}>
                      <span>
                        <button
                          type="button"
                          onClick={() => {
                            if (platform === 'SOF2') {
                              window.location.replace(
                                request.getSSOLoginState()
                                  ? `${sof2ApiHost}/users/sso-login?url=${JSON.stringify(
                                      {
                                        title,
                                        name,
                                        formField: form.fields
                                      }
                                    )}`
                                  : sof2HomeUrl
                              );
                            } else {
                              history.push(url);
                              history.go();
                            }
                          }}
                          className={
                            form.fields.title === 'Reporting' ||
                            form.fields.title === 'Rapports'
                              ? 'frg-button color-purple'
                              : 'frg-button color-green'
                          }
                        >
                          {form.fields.title}
                        </button>
                      </span>
                      &nbsp;
                    </Fragment>
                  )}
                </>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

FormCategory.propTypes = {
  category: PropTypes.shape({
    title: PropTypes.string,
    name: PropTypes.string,
    image: PropTypes.object,
    description: PropTypes.object,
    info: PropTypes.string,
    importantInfo: PropTypes.string,
    forms: PropTypes.arrayOf(PropTypes.object),
    platform: PropTypes.string
  }),
  row: PropTypes.number.isRequired,
  locale: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
    go: PropTypes.func
  }).isRequired
};

FormCategory.defaultProps = {
  category: null
};

export default FormCategory;
